export enum LibertyRxLoadInventoryStatusValues {
  NotLoading,
  Created,
  Processing,
  Processed,
  Failed
}

export interface ILibertyRxLoadInventoryStatus {
    totalPagesCount: number;
    loadedPagesCount: number;
    percentageCompleted: number;
    c2Count: number;
    hasErrors: boolean;
    userAcknowledged: boolean;
    status: LibertyRxLoadInventoryStatusValues;
}
